var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02456 5.88098L3.77456 11.506C3.71892 11.5654 3.64548 11.605 3.56533 11.619C3.48517 11.633 3.40264 11.6205 3.33019 11.5835C3.25775 11.5464 3.19932 11.4868 3.16372 11.4136C3.12811 11.3405 3.11728 11.2577 3.13284 11.1779L3.82002 7.74051L1.11862 6.72613C1.0606 6.70443 1.00887 6.6687 0.96803 6.62212C0.927194 6.57555 0.898532 6.51958 0.884603 6.45922C0.870675 6.39887 0.871915 6.336 0.888211 6.27624C0.904508 6.21648 0.935354 6.16169 0.977994 6.11676L6.22799 0.491759C6.28363 0.432385 6.35707 0.392718 6.43722 0.378742C6.51738 0.364767 6.59991 0.377242 6.67236 0.414285C6.7448 0.451328 6.80323 0.510929 6.83883 0.584094C6.87444 0.65726 6.88527 0.740019 6.86971 0.819884L6.18065 4.26098L8.88206 5.27395C8.93964 5.29579 8.99097 5.33149 9.03148 5.37788C9.072 5.42427 9.10047 5.47993 9.11437 5.53993C9.12827 5.59994 9.12718 5.66244 9.11119 5.72192C9.09519 5.78141 9.0648 5.83603 9.02268 5.88098H9.02456Z",
    fill: "#F79009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderBolt);
export default __webpack_public_path__ + "static/media/thunder-bolt.a0d2466b2be8b8182bc813309343c2bc.svg";
export { ForwardRef as ReactComponent };